var styles = {"container":"styles_container__9ot2R flex flex-column items-center justify-center","message":"styles_message__3RqP4","name":"styles_name__1-PEC","category":"styles_category__14EGb"};

export default styles;
//# sourceMappingURL=styles.css.js.map
